import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { Label } from '@ui/Label';
import { makeStyles } from 'tss-react/mui';
import {
  getProductElementClimateTagEpdTooltip,
  PRODUCT_ELEMENT_CLIMATE_TAG_LABEL,
  type ProductElementClimateTag as ProductElementClimateTagValue,
} from '@shared/helpers/product-element.helpers';
import { Tooltip } from '@ui/Tooltip';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    gap: theme.spacing(0.75),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.75),
  },
}));

export type ProductElementClimateTagProps = {
  tag: ProductElementClimateTagValue;
};

/**
 * EPD badge beside a product name. Hover shows the EPD name and carbon efficiency
 * percent vs generic baseline, e.g. `EPD gypsum (-37%)` (DEV-3479).
 */
export const ProductElementClimateTag: React.FC<
  ProductElementClimateTagProps
> = ({ tag }) => {
  const { classes } = useStyles();
  const stopRowPointerDown = useCallback((event: React.PointerEvent) => {
    event.stopPropagation();
  }, []);

  const badge = (
    <Label
      label={PRODUCT_ELEMENT_CLIMATE_TAG_LABEL}
      onPointerDown={stopRowPointerDown}
    />
  );

  return (
    <Box className={classes.root}>
      <Tooltip
        title={getProductElementClimateTagEpdTooltip(tag)}
        placement="top"
        arrow
      >
        {badge}
      </Tooltip>
    </Box>
  );
};
